<template>
  <div style="width:100%">
    <div class="col-12 cart-header" v-if="!miniCart && !checkoutCart">
      <div class="row p-3">
        <div class="col-4 text-left cart-header-title">{{ t('products') }}</div>
        <div class="col-2 text-center cart-header-title">{{ t('price') }} / {{ t('package') }}</div>
        <div class="col-2 text-center cart-header-title">{{ t('quantity') }}</div>
        <div class="col-2 text-center cart-header-title"></div>
        <div class="col-2 cart-header-title">{{ t('total') }}</div>
      </div>
    </div>
    <adv-cart-product-row
      v-for="(cartProduct, index) in cartProductContents"
      :key="index"
      :checkout-cart="checkoutCart"
      :mini-cart="miniCart"
      :read-only="readOnly"
      :disable-product-links="disableProductLinks"
      :cart-product="cartProduct"></adv-cart-product-row>
  </div>
</template>

<script>
import store from '../../vue/store'
import AdvCartProductRow from './AdvCartProductRow'

export default {
  name: 'AdvCartProductList',
  components: {
    AdvCartProductRow
  },
  props: {
    checkoutCart: {
      type: Boolean,
      default: false
    },
    miniCart: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.3'
    }
  },
  computed: {
    cartProductContents () {
      return store.getters.cartContents
    },
    getSelectedCurrency () {
      return store.getters.selectedCurrency
    }
  },
  methods: {
    removeProductFromCart () {
      store.dispatch('addToCartClicked', {
        productCodeId: this.productCodeId,
        quantity: 0
      })
    }
  }
}
</script>
